import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import React, { useContext, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { api } from "../../../redux/api";
import { set } from "lodash";
import { newTemplateActions } from "../../../redux/slices/newTemplateSlice";
import { treeActions } from "../../../redux/slices/treeSlice";
import inputValidation from "../../../utils/inputValidation";

export const CopyWorkflowGroup = ({ openModal, onClose }) => {
  const { t } = useTranslation();
  const [wfgName, setWfgName] = useState("");
  const [valid, setValid] = useState(true);
  const [responseLoading, setResponseLoading] = useState(false);
  const error = useRef(null);
  const parentScreen = useContext(ParentScreenCtx);
  const { leftTree } = useSelector((state) => state.treeData[parentScreen]);
  const account = useSelector((state) => state.queryParams.account);
  const selectedNode = leftTree?.tree?.body?.selectedNode;
  const dispatch = useDispatch();

  const handleCancel = () => {
    onClose();
  };
  
  const validateInput = (input) => {
    if (inputValidation(input) === "") {
      error.current.textContent = t("BOX_ENTER_NEW_NM_FOR_NEW_WF_GROUP");
      setValid(false);
      return false;
    } else if (inputValidation(input) === "invalid") {
      error.current.textContent = t(
        "BOX_WF_NAMES_CANNOT_CONTAIN_CERTAIN_CHARS_OR_SPACES"
      );
      setValid(false);
      return false;
    } else if (input.length > 50) {
      const errorMsg = t("BOX_MAX_LENGTH_FOR_NAME_IS").replace(/\{0\}/, "50");
      error.current.textContent = errorMsg;
      setValid(false);
      return false;
    }
    return true;
  };

  const handleOk = async () => {
    if (validateInput(wfgName.trim())) {
      setResponseLoading(true);
      const response = await dispatch(
        api.endpoints.copyWorkflowGroup.initiate({
          account: account,
          sourceWorkflowGroupName: encodeURIComponent(selectedNode?.title),
          workflowGroupName: encodeURIComponent(wfgName.trim()),
        })
      );
      
      if (response?.error) {
        const errorMsg =
          response?.message ||
          response?.data?.message ||
          t("BOX_MSG_GENERAL_ERROR");
        error.current.textContent = errorMsg;
        setValid(false);
        setResponseLoading(false);
        return;
      } else if (response?.data?.current_state === "SUCCESS") {
        setResponseLoading(false);
        dispatch(newTemplateActions.setShowAlert(true));
        dispatch(
          newTemplateActions.setAlertMessage(
            response.data.message || "Workflow Group copied successfully."
          )
        );
        dispatch(
          treeActions.setLeftTreeContextActionValue({
            screen: parentScreen,
            data: response?.data?.data?.workflow_name,
          })
        );

        dispatch(
          api.endpoints.getInboundTemplateList.initiate(
            { account },
            { subscribe: false, forceRefetch: true }
          )
        );
        dispatch(
          api.endpoints.getOutboundTemplateList.initiate(
            { account },
            { subscribe: false, forceRefetch: true }
          )
        );
        dispatch(
          api.endpoints.getWorkflows.initiate(
            { account },
            { subscribe: false, forceRefetch: true }
          )
        );
        onClose();
        return;
      } else {
        setResponseLoading(false);
        error.current.textContent = t("BOX_MSG_GENERAL_ERROR");
        setValid(false);
      }
    }
  };
  return (
    <>
      <Dialog onClose={onClose} open={openModal} maxWidth="xs">
        <DialogTitle className="dialog-header">
          <div className="title">{t("DIAG_COPY_WFG_TITLE")}</div>
        </DialogTitle>
        <DialogContent className="modal-content" dividers>
          <div style={{ marginBottom: "20px" }}>
            {t("DIAG_COPY_WFG_DESC")} <strong>{selectedNode?.title}</strong>
          </div>

          <div className={"default-delimiter-field"}>
            <TextField
              variant="outlined"
              size="small"
              type="text"
              autoFocus={true}
              autoComplete="off"
              value={wfgName}
              label={t("LBL_NEW_WF_GROUP_NAME")}
              error={!valid}
              onChange={(e) => {
                setWfgName(e.target.value);
                error.current.textContent = "";
                setValid(true);
              }}
            />
          </div>
          <p className="error" ref={error}></p>
        </DialogContent>
        <DialogActions>
          <Button
            size="small"
            variant="outlined"
            color="primary"
            disabled={!wfgName || !valid}
            onClick={handleOk}>
            {responseLoading ? <CircularProgress size={16} /> : t("BTN_OK")}
          </Button>
          <Button
            size="small"
            variant="outlined"
            color="primary"
            disabled={responseLoading}
            onClick={handleCancel}>
            {t("CANCEL")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
